/* PupTailor Christmas 2026 — countdown, price tabs, name preview, collection chips / sort / "Show more".
   No dependencies; every feature works from server-rendered markup and only enhances it.
   Buying stays with the shared PTQuickBuy layer (snippets/pt-quick-buy-loader.liquid); nothing here adds to cart. */
(function () {
  if (window.PTXmas) return;
  window.PTXmas = true;

  /* Countdown: [data-pt-xmas-cd="ISO"] with [data-d] [data-h] [data-m] children. Refreshes every 30 s, no seconds;
     the whole group hides once the target has passed. */
  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-pt-xmas-cd]').forEach(function (el) {
      var t = Date.parse(el.getAttribute('data-pt-xmas-cd'));
      if (isNaN(t)) return;
      var left = Math.floor((t - now) / 60000);
      var hide = el.closest('[data-pt-xmas-cd-group]') || el;
      if (left <= 0) { hide.hidden = true; return; }
      var d = Math.floor(left / 1440), h = Math.floor((left % 1440) / 60), m = left % 60;
      set(el, '[data-d]', d);
      set(el, '[data-h]', h);
      set(el, '[data-m]', m);
    });
  }
  function set(root, sel, v) {
    root.querySelectorAll(sel).forEach(function (n) { if (n.textContent !== String(v)) n.textContent = v; });
  }

  /* Price tabs (phone + tablet): ARIA tablist, arrow keys move between tabs. */
  function initTabs(root) {
    root.querySelectorAll('[data-pt-xmas-tabs]').forEach(function (list) {
      if (list.ptReady) return;
      list.ptReady = true;
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = document.getElementById(t.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') n = tabs[0];
          else if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* Name preview: every [data-pt-xmas-name-input] in a section writes to that section's [data-pt-xmas-name]. */
  function initNames(root) {
    root.querySelectorAll('[data-pt-xmas-name-input]').forEach(function (input) {
      if (input.ptReady) return;
      input.ptReady = true;
      var scope = input.closest('[data-pt-xmas-section]') || document;
      var fallback = input.getAttribute('data-empty') || 'Your pup';
      input.addEventListener('input', function () {
        var v = input.value.slice(0, 12);
        scope.querySelectorAll('[data-pt-xmas-name-input]').forEach(function (o) { if (o !== input) o.value = v; });
        scope.querySelectorAll('[data-pt-xmas-name]').forEach(function (n) { n.textContent = v.trim() ? v : fallback; });
      });
    });
  }

  /* Collection chips: mark the chip whose filter query matches the current URL (ignoring page / sort). */
  function norm(search) {
    var p = new URLSearchParams(search);
    var out = [];
    p.forEach(function (v, k) { if (k !== 'page' && k !== 'sort_by' && k !== 'view' && k !== 'preview_theme_id' && k !== 'pin' && k !== 'pin_product' && k !== 'pin_debug' && k.indexOf('_') !== 0) out.push(k + '=' + v); });
    return out.sort().join('&');
  }
  function initChips(root) {
    root.querySelectorAll('[data-pt-xmas-chips]').forEach(function (wrap) {
      var here = norm(location.search);
      var hit = null, all = null;
      wrap.querySelectorAll('a[data-pt-xmas-chip]').forEach(function (a) {
        a.removeAttribute('aria-current');
        var u = new URL(a.href, location.href);
        if (decodeURIComponent(u.pathname).toLowerCase() !== decodeURIComponent(location.pathname).toLowerCase()) return;
        var q = norm(u.search);
        if (!q) all = a;
        if (q && q === here) hit = a;
      });
      var on = hit || (!here ? all : null);
      if (on) on.setAttribute('aria-current', 'true');
      // keep the theme preview and the alternate template while browsing chips
      var keep = new URLSearchParams(location.search);
      wrap.querySelectorAll('a[data-pt-xmas-chip]').forEach(function (a) {
        var u = new URL(a.href, location.href);
        ['view', 'preview_theme_id', 'sort_by', 'pin', 'pin_product'].forEach(function (k) { if (keep.get(k) && !u.searchParams.get(k)) u.searchParams.set(k, keep.get(k)); });
        a.href = u.pathname + u.search;
      });
    });
  }

  /* Sort select → reload with sort_by, keeping filters. */
  function initSort(root) {
    root.querySelectorAll('[data-pt-xmas-sort]').forEach(function (sel) {
      if (sel.ptReady) return;
      sel.ptReady = true;
      sel.addEventListener('change', function () {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', sel.value);
        u.searchParams.delete('page');
        location.href = u.pathname + u.search;
      });
    });
  }

  /* Sticky bar sits under Dawn's sticky header while that header is showing. */
  function stickyOffset() {
    var bar = document.querySelector('.pt-xmas-bar');
    if (!bar) return;
    var header = document.querySelector('.section-header');
    function update() {
      var top = 0;
      if (header && header.classList.contains('shopify-section-header-sticky') && !header.classList.contains('shopify-section-header-hidden')) {
        top = Math.max(0, header.getBoundingClientRect().bottom);
      }
      bar.style.setProperty('--pt-xmas-sticky-top', top + 'px');
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  /* "Show more gifts": fetch the next page of this section and append its cards (no JS → plain pagination links). */
  function initMore(root) {
    root.querySelectorAll('[data-pt-xmas-more]').forEach(function (btn) {
      if (btn.ptReady) return;
      btn.ptReady = true;
      var wrap = btn.closest('[data-pt-xmas-section]');
      var grid = wrap && wrap.querySelector('[data-pt-xmas-grid]');
      var count = wrap && wrap.querySelector('[data-pt-xmas-shown]');
      var pages = wrap && wrap.querySelector('[data-pt-xmas-pages]');
      if (pages) pages.hidden = true;
      btn.hidden = false;
      btn.addEventListener('click', function () {
        if (grid && grid.hasAttribute('data-pin-collection') && window.ptXmasPin && window.ptXmasPin.active) {
          window.ptXmasPin.more();
          return;
        }
        var next = btn.getAttribute('data-next');
        if (!next || !grid) return;
        btn.setAttribute('aria-busy', 'true');
        var u = new URL(next, location.href);
        u.searchParams.set('section_id', btn.getAttribute('data-section'));
        fetch(u.pathname + u.search, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var g = doc.querySelector('[data-pt-xmas-grid]');
            var nb = doc.querySelector('[data-pt-xmas-more]');
            if (g) g.querySelectorAll('[data-pt-xmas-item]').forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
            var shown = grid.querySelectorAll('[data-pt-xmas-item]').length;
            if (count) count.textContent = shown;
            var n2 = nb && nb.getAttribute('data-next');
            if (n2) btn.setAttribute('data-next', n2); else btn.closest('.pt-xmas-more__actions').hidden = true;
            btn.removeAttribute('aria-busy');
          })
          .catch(function () { location.href = next; });
      });
    });
  }

  function init(root) {
    root = root || document;
    initTabs(root);
    initNames(root);
    initChips(root);
    initSort(root);
    initMore(root);
    tick();
  }

  function start() {
    init(document);
    stickyOffset();
    setInterval(tick, 30000);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
